import ChecklistItemForm from "../../mixins/checklist-item-form";
import DropzoneOptions from "../../mixins/dropzone-options";

Vue.component("checklist-item-row", {

    mixins: [ChecklistItemForm, DropzoneOptions],

    props: ["item", "selected"],
    data () {
        return {
            form: new AppForm({
                item: this.item.item,
                cleanliness: this.item.cleanliness,
                damage: this.item.damage,
                functioning: this.item.functioning,
                recommendation: this.item.recommendation,
                comments: this.item.comments
            }),
            checklistItem: this.item,
            duringTransition: false,
        };
    },

    created () {
        this.updateFormValues();
    },

    watch: {

        item (newVal) {
            this.checklistItem = newVal;
            this.updateFormValues();
        }

    },

    computed: {

        hasCleanlinessValue () {
            return this.form.cleanliness;
        },

        hasDamageValue () {
            return this.form.damage;
        },

        hasFunctioningValue () {
            return this.form.functioning;
        },

        commentIcon () {
            return this.form.comments ? "/images/comment-full.svg" : "/images/comment-empty.svg";
        },

        recommendationIcon () {
            return this.form.recommendation ? "/images/recommendation-full.svg" : "/images/recommendation-empty.svg";
        }

    },

    methods: {

        updateFormValues () {
            this.form.item = this.checklistItem.item;
            this.form.cleanliness = this.checklistItem.cleanliness;
            this.form.damage = this.checklistItem.damage;
            this.form.functioning = this.checklistItem.functioning;
            this.form.recommendation = this.checklistItem.recommendation;
            this.form.comments = this.checklistItem.comments;
        },

        setCleanliness (cleanliness = null) {
            this.form.cleanliness = cleanliness;
            this.update();
        },

        setDamage (damage = null) {
            this.form.damage = damage;
            this.update();
        },

        setFunctioning (functioning = null) {
            this.form.functioning = functioning;
            this.update();
        },

        setRecommendation (recommendation) {

            if (recommendation === "Other") {
                this.edit();
                return;
            }

            this.form.recommendation = recommendation;
            this.update();

        },

        update () {

            App.patch("/inspections/items/" + this.checklistItem.id + "/update", this.form)
            .then(response => {
                this.checklistItem = response;

                if (this.isEditing) {
                    $("#modal-checklist-item-edit-form-" + this.checklistItem.id).modal("hide");
                }

                this.$emit("item-updated", response);

            })
            .catch(errors => {
                toastr.error(errors.message);
            });

        },

        edit () {
            this.$emit("edit-item", this.checklistItem);
        },

        deleteItem () {

            let self = this;
            swal({
                title: "Delete " + this.checklistItem.item,
                text: "Are you sure you want to delete this item?",
                showCancelButton: true
            }).then((result) => {
                if (result.value) {
                    axios.post("/inspections/items/" + self.checklistItem.id + "/delete", {_method: "DELETE"})
                    .then(response => {
                        self.$emit("item-deleted", self.checklistItem);
                    })
                    .catch(errors => {
                        toastr.error("Item could not be deleted.");
                    });
                }
            });

        },

        togglePhotosPanel () {
            this.$emit("view-photos", this.checklistItem);
        },

        toggleItemSelection () {
            Bus.$emit("item-selected",  {
                id: this.checklistItem.id,
                item: this.checklistItem.item,
                area_name: this.checklistItem.area_name,
                cleanliness: this.checklistItem.cleanliness,
                damage: this.checklistItem.damage,
                functioning: this.checklistItem.functioning,
                comments: this.checklistItem.comments,
                recommendation: this.checklistItem.recommendation,
                photo: this.checklistItem.photo
            });
        },

        ticketClass (issue) {
            if (issue.inspection_ticket.status === "open") {

                switch (issue.inspection_ticket.priority) {
                    case "Low":
                        return "priority-low";
                    case "Medium":
                        return "priority-medium";
                    case "High":
                        return "priority-high";
                }

            }
            return "";
        },

        dragOver (event) {
            // Add some visual fluff to show the user can drop its files
            if (!event.currentTarget.classList.contains("border-gray-400")) {
                event.currentTarget.classList.remove("border-white");
                event.currentTarget.classList.add("bg-blue-50", "border-gray-400");
            }
        },

        dragLeave (event) {
            // Clean up
            event.currentTarget.classList.remove("border-gray-400", "bg-blue-50");
            event.currentTarget.classList.add("border-white");
        },

        fileDropped (event) {
            this.dragLeave(event);
        },

        fileUploaded (file, response) {
            // give item to refresh photo list
            this.$emit("photo-uploaded", this.checklistItem);
            // In this case we use the url instead of the url_thumb_md as they might not have finished
            // generating in S3 by the time the browser tries to load it.
            this.$set(this.item, "photo", response.url);
            toastr.success(this.fileName + " has successfully uploaded");
        },

        uploadErrorsFound (file, message, xhr) {
            const isImg = ["image/jpeg", "image/png"].includes(_.toLower(file.type));
            const isLt3M = file.size / 1024 / 1024 < 3;

            if (!isLt3M) {
                toastr.error("Photo file size can not exceed 3MB! Try using <a style='color: yellow' href='https://tinypng.com/' target='_blank'>TinyPNG</a> to compress your photos");
            }

            if (!isImg) {
                toastr.error("Only jpg and png photos allowed!");
            }
        },

        // used in checklist-item.blade, to not have the padding immediately be removed when processingUploading is false.
        toggleTransition () {
            this.duringTransition = !this.duringTransition;
        }
    }
});
